import tooltipCopy from '../tooltipCopy';
import tooltipOverrides from './tooltipCopy';

const { defineMessages } = require('@sm/intl');

const TYPE_LABEL = '[Type: Label][Vis: high] - Feature Set List Item';
const GLOBAL_BENCHMARKS = 'SurveyMonkey Global Benchmarks';
const RESPONSES_PER_YEAR = 'Number of responses';
const SHARED_LIBRARY = 'Shared library';

export default defineMessages({
  ...tooltipCopy,
  ...tooltipOverrides,
  '508_accessibility': {
    id: 'PricingDetails.Feature.508Accessibility',
    defaultMessage: 'Fully accessible, 508 compliant surveys',
    desc: TYPE_LABEL,
  },
  a_b_testing: {
    id: 'PricingDetails.Feature.ABTesting',
    defaultMessage: 'A/B test question type',
    desc: TYPE_LABEL,
  },
  account_control: {
    id: 'PricingDetails.Feature.AccountControl',
    defaultMessage: 'Account control',
    desc: TYPE_LABEL,
  },
  account_verification: {
    id: 'PricingDetails.Feature.AccountVerification',
    defaultMessage: 'Account Verification',
    desc: TYPE_LABEL,
  },
  add_users: {
    id: 'PricingDetails.Feature.AddUsers',
    defaultMessage: 'Additional Full User Accounts',
    desc: TYPE_LABEL,
  },
  admin_dashboard: {
    id: 'PricingDetails.Feature.AdminDashboard',
    defaultMessage: 'Admin dashboard',
    desc: TYPE_LABEL,
  },
  advanced_logic: {
    id: 'PricingDetails.Feature.AdvancedLogic',
    defaultMessage: 'Advanced survey logic',
    desc: TYPE_LABEL,
  },
  advanced_survey_features: {
    id: 'PricingDetails.Feature.AdvancedSurveyFeatures',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: TYPE_LABEL,
  },
  all_languages_supported: {
    id: 'PricingDetails.Feature.AllLanguagesSupported',
    defaultMessage: 'All languages supported',
    desc: TYPE_LABEL,
  },
  analyze_can_customize_charts: {
    id: 'PricingDetails.Feature.AnalyzeCanCustomizeCharts',
    defaultMessage: 'Generate custom charts & reports',
    desc: TYPE_LABEL,
  },
  analyze_can_export_hide_branding: {
    id: 'PricingDetails.Feature.AnalyzeCanExportHideBranding',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  analyze_can_export_ta: {
    id: 'PricingDetails.Feature.AnalyzeCanExportTA',
    defaultMessage: 'Analyze Export TA',
    desc: TYPE_LABEL,
  },
  analyze_can_save_views: {
    id: 'PricingDetails.Feature.AnalyzeCanSaveViews',
    defaultMessage: 'Analyze Save Views',
    desc: TYPE_LABEL,
  },
  analyze_can_share_customize_branding: {
    id: 'PricingDetails.Feature.AnalyzeCanShareCustomizeBranding',
    defaultMessage: 'Add your logo',
    desc: TYPE_LABEL,
  },
  analyze_can_share_customize_domain: {
    id: 'PricingDetails.Feature.AnalyzeCanShareCustomizeDomain',
    defaultMessage: 'Custom SurveyMonkey URL',
    desc: TYPE_LABEL,
  },
  analyze_can_ta_search: {
    id: 'PricingDetails.Feature.AnalyzeCanTASearch',
    defaultMessage: 'Analyze TA Search',
    desc: TYPE_LABEL,
  },
  analyze_can_ta_tag: {
    id: 'PricingDetails.Feature.AnalyzeCanTATag',
    defaultMessage: 'Tag written answers',
    desc: TYPE_LABEL,
  },
  analyze_combine_filters: {
    id: 'PricingDetails.Feature.CombineFilters',
    defaultMessage: 'Filter & compare results',
    desc: TYPE_LABEL,
  },
  analyze_dashboard_password_enabled: {
    id: 'PricingDetails.Feature.AnalyzeDashboardPasswordEnabled',
    defaultMessage: 'Dashboard: Password protection',
    desc: TYPE_LABEL,
  },
  analyze_delete_respondent_limit: {
    id: 'PricingDetails.Feature.AnalyzeDeleteRespondentLimit',
    defaultMessage: 'Analyze Delete Respondent Limit',
    desc: TYPE_LABEL,
  },
  analyze_export_enabled: {
    id: 'PricingDetails.Feature.AnalyzeExportEnabled',
    defaultMessage: 'Download results as CSV, XLS or PDF',
    desc: TYPE_LABEL,
  },
  analyze_export_spss_enabled: {
    id: 'PricingDetails.Feature.AnalyzeExportSpssEnabled',
    defaultMessage: 'Export to SPSS',
    desc: TYPE_LABEL,
  },
  analyze_integrations: {
    id: 'PricingDetails.Feature.AnalyzeIntegrations',
    defaultMessage: 'Extract data',
    desc: TYPE_LABEL,
  },
  analyze_password_enabled: {
    id: 'PricingDetails.Feature.AnalyzePasswordEnabled',
    defaultMessage: 'Analyze Password Enabled',
    desc: TYPE_LABEL,
  },
  analyze_response_delete_limit: {
    id: 'PricingDetails.Feature.AnalyzeResponseDeleteLimit',
    defaultMessage: 'Analyze Response Delete Limit',
    desc: TYPE_LABEL,
  },
  analyze_response_limit: {
    id: 'PricingDetails.Feature.AnalyzeResponseLimit',
    defaultMessage: RESPONSES_PER_YEAR,
    desc: TYPE_LABEL,
  },
  analyze_results_together: {
    id: 'PricingDetails.Feature.AnalyzeResultsTogether',
    defaultMessage: 'Analyze results together',
    desc: TYPE_LABEL,
  },
  analyze_rule_limit: {
    id: 'PricingDetails.Feature.AnalyzeRuleLimit',
    defaultMessage: 'Analyze Rule Limit',
    desc: TYPE_LABEL,
  },
  analyze_sentiment_enabled: {
    id: 'PricingDetails.Feature.AnalyzeSentimentEnabled',
    defaultMessage: 'Sentiment analysis',
    desc: TYPE_LABEL,
  },
  analyze_shared_results_enabled: {
    id: 'PricingDetails.Feature.AnalyzeSharedResultsEnabled',
    defaultMessage: 'Analyze Shared Results Enabled',
    desc: TYPE_LABEL,
  },
  analyze_ta_enabled: {
    id: 'PricingDetails.Feature.AnalyzeTAEnabled',
    defaultMessage: 'Word clouds',
    desc: TYPE_LABEL,
  },
  analyze_trends_enabled: {
    id: 'PricingDetails.Feature.AnalyzeTrendsEnabled',
    defaultMessage: 'Data trends',
    desc: TYPE_LABEL,
  },
  api_access: {
    id: 'PricingDetails.Feature.ApiAccess',
    defaultMessage: 'API Access',
    desc: TYPE_LABEL,
  },
  asset_library: {
    id: 'PricingDetails.Feature.AssetLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: TYPE_LABEL,
  },
  assign_admin_role: {
    id: 'PricingDetails.Feature.AssignAdminRole',
    defaultMessage: 'Assign Admin Role',
    desc: TYPE_LABEL,
  },
  base_response_count: {
    id: 'PricingDetails.Feature.BaseResponseCount',
    defaultMessage: RESPONSES_PER_YEAR,
    desc: TYPE_LABEL,
  },
  benchmarks: {
    id: 'PricingDetails.Feature.Benchmarks',
    defaultMessage: 'SurveyMonkey Industry Benchmarks',
    desc: TYPE_LABEL,
  },
  best_worst_qt: {
    id: 'PricingDetails.Feature.BestWorstQT',
    defaultMessage: 'Best Worst QT',
    desc: TYPE_LABEL,
  },
  build_surveys_together: {
    id: 'PricingDetails.Feature.BuildSurveysTogether',
    defaultMessage: 'Build surveys together',
    desc: TYPE_LABEL,
  },
  bulk_survey_share: {
    id: 'PricingDetails.Feature.BulkSurveyShare',
    defaultMessage: 'Bulk Survey Share',
    desc: TYPE_LABEL,
  },
  bulk_survey_transfer: {
    id: 'PricingDetails.Feature.BulkSurveyTransfer',
    defaultMessage: 'Bulk Survey Transfer',
    desc: TYPE_LABEL,
  },
  carry_forward: {
    id: 'PricingDetails.Feature.CarryForward',
    defaultMessage: 'Carry forward responses',
    desc: TYPE_LABEL,
  },
  click_map_qt: {
    id: 'PricingDetails.Feature.ClickMapQT',
    defaultMessage: 'Click map data visualization',
    desc: TYPE_LABEL,
  },
  collaboration: {
    id: 'PricingDetails.Feature.Collaboration',
    defaultMessage: 'Advanced permissions',
    desc: TYPE_LABEL,
  },
  collect_contact_information: {
    id: 'PricingDetails.Feature.CollectContactInformation',
    defaultMessage: 'Collect Contact Information',
    desc: TYPE_LABEL,
  },
  collect_email_throttle_limit: {
    id: 'PricingDetails.Feature.CollectEmailThrottleLimit',
    defaultMessage: 'Collect Email Throttle Limit',
    desc: TYPE_LABEL,
  },
  collect_min_daily_messages_limit: {
    id: 'PricingDetails.Feature.CollectMinDailyMessagesLimit',
    defaultMessage: 'Collect Min Daily Messages Limit',
    desc: TYPE_LABEL,
  },
  collect_responses: {
    id: 'PricingDetails.Feature.CollectResponses',
    defaultMessage: 'Collect Responses',
    desc: TYPE_LABEL,
  },
  collector_completion_url_enabled: {
    id: 'PricingDetails.Feature.CollectorCompletionUrlEnabled',
    defaultMessage: 'Survey completion redirect',
    desc: TYPE_LABEL,
  },
  collector_contact_list_limit: {
    id: 'PricingDetails.Feature.CollectorContactListLimit',
    defaultMessage: 'Collector Contact List Limit',
    desc: TYPE_LABEL,
  },
  collector_create_limit: {
    id: 'PricingDetails.Feature.CollectorCreateLimit',
    defaultMessage: 'Number of collectors',
    desc: TYPE_LABEL,
  },
  collector_email_limit: {
    id: 'PricingDetails.Feature.CollectorEmailLimit',
    defaultMessage: 'Collector Email Limit',
    desc: TYPE_LABEL,
  },
  collector_email_enabled: {
    id: 'PricingDetails.Feature.CollectorEmailEnabled',
    defaultMessage: 'Collector Email Enabled',
    desc: TYPE_LABEL,
  },
  collector_facebook_messenger_enabled: {
    id: 'PricingDetails.Feature.CollectorFacebookMessengerEnabled',
    defaultMessage: 'Collector Facebook Messenger Enabled',
    desc: TYPE_LABEL,
  },
  collector_manual_data_entry_enabled: {
    id: 'PricingDetails.Feature.CollectorManualDataEntryEnabled',
    defaultMessage: 'Collector Manuanl Data Entry Enabled',
    desc: TYPE_LABEL,
  },
  collector_mobile_sdk_enabled: {
    id: 'PricingDetails.Feature.CollectorMobileSdkEnabled',
    defaultMessage: 'Mobile SDK',
    desc: TYPE_LABEL,
  },
  collector_offline_kiosk_enabled: {
    id: 'PricingDetails.Feature.CollectorOfflineKioskEnabled',
    defaultMessage: 'Kiosk Mode: Inactivity Timer, Kiosk Mode: Passcode Lock',
    desc: TYPE_LABEL,
  },
  collector_popup_enabled: {
    id: 'PricingDetails.Feature.CollectorPopupEnabled',
    defaultMessage: 'Pop up online surveys',
    desc: TYPE_LABEL,
  },
  collector_friendly_url_enabled: {
    id: 'PricingDetails.Feature.CollectorFriendlyUrlEnabled',
    defaultMessage: 'Custom SurveyMonkey URL',
    desc: TYPE_LABEL,
  },
  collector_max_responses_delete_count: {
    id: 'PricingDetails.Feature.CollectorMaxResponsesDeleteCount',
    defaultMessage: 'Collector Max Responses Delete Count',
    desc: TYPE_LABEL,
  },
  collector_recipients_limit: {
    id: 'PricingDetails.Feature.CollectorRecipientsLimit',
    defaultMessage: 'Collector Recipients Limit',
    desc: TYPE_LABEL,
  },
  collector_thank_you_enabled: {
    id: 'PricingDetails.Feature.CollectorThankYouEnabled',
    defaultMessage: `Display a 'thank you' page`,
    desc: TYPE_LABEL,
  },
  collector_white_label_enabled: {
    id: 'PricingDetails.Feature.CollectorWhiteLabelEnabled',
    defaultMessage: 'White label surveys',
    desc: TYPE_LABEL,
  },
  collector_zoom_enabled: {
    id: 'PricingDetails.Feature.CollectorZoomEnabled',
    defaultMessage: 'Collector Zoom Enabled',
    desc: TYPE_LABEL,
  },
  collectors_read: {
    id: 'PricingDetails.Feature.CollectorsRead',
    defaultMessage: 'Collectors Read',
    desc: TYPE_LABEL,
  },
  collectors_write: {
    id: 'PricingDetails.Feature.CollectorsWrite',
    defaultMessage: 'Collectors Write',
    desc: TYPE_LABEL,
  },
  collect_end_page_question_bank_demographics: {
    id: 'PricingDetails.Feature.CollectEndPageQuestionBankDemographics',
    defaultMessage: 'Collect End Page Question Bank Demographics',
    desc: TYPE_LABEL,
  },
  comment_box_question_type: {
    id: 'PricingDetails.Feature.CommentBoxQuestionType',
    defaultMessage: 'Comment Box Question Type',
    desc: TYPE_LABEL,
  },
  consolidated_billing: {
    id: 'PricingDetails.Feature.ConsolidatedBilling',
    defaultMessage: 'Consolidated billing',
    desc: TYPE_LABEL,
  },
  contacts_read: {
    id: 'PricingDetails.Feature.ContactsRead',
    defaultMessage: 'Contacts Read',
    desc: TYPE_LABEL,
  },
  contacts_write: {
    id: 'PricingDetails.Feature.ContactsWrite',
    defaultMessage: 'Contacts Write',
    desc: TYPE_LABEL,
  },
  contributor_seats: {
    id: 'PricingDetails.Feature.ContactsWrite',
    defaultMessage: 'Contributor Seats',
    desc: TYPE_LABEL,
  },
  create_custom_chatbot_avatar: {
    id: 'PricingDetails.Feature.CreateCustomChatbotAvatar',
    defaultMessage: 'Create Custom Chatbot Avatar',
    desc: TYPE_LABEL,
  },
  create_custom_html_email_message_enabled: {
    id: 'PricingDetails.Feature.CreateCustomHtmlEmailMessageEnabled',
    defaultMessage: 'Custom HTML email invitations',
    desc: TYPE_LABEL,
  },
  create_custom_theme_enabled: {
    id: 'PricingDetails.Feature.CreateCustomThemeEnabled',
    defaultMessage: 'Custom themes, colors & more',
    desc: TYPE_LABEL,
  },
  create_custom_variables_enabled: {
    id: 'PricingDetails.Feature.CreateCustomVariablesEnabled',
    defaultMessage: 'Custom variables',
    desc: TYPE_LABEL,
  },
  create_grayscale_footer: {
    id: 'PricingDetails.Feature.CreateGrayscaleFooter',
    defaultMessage: 'Subtle SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  create_logo_enabled: {
    id: 'PricingDetails.Feature.CreateLogoEnabled',
    defaultMessage: 'Add your logo',
    desc: TYPE_LABEL,
  },
  create_piping_enabled: {
    id: 'PricingDetails.Feature.CreatePipingEnabled',
    defaultMessage: 'Question & answer piping',
    desc: TYPE_LABEL,
  },
  create_print_enabled: {
    id: 'PricingDetails.Feature.CreatePrintEnabled',
    defaultMessage: 'Print reports',
    desc: TYPE_LABEL,
  },
  create_question_limit: {
    id: 'PricingDetails.Feature.CreateQuestionLimit',
    defaultMessage: 'Questions per survey',
    desc: TYPE_LABEL,
  },
  create_quotas_enabled: {
    id: 'PricingDetails.Feature.CreateQuotasEnabled',
    defaultMessage: 'Response quotas',
    desc: TYPE_LABEL,
  },
  create_random_assignment_enabled: {
    id: 'PricingDetails.Feature.CreateRandomAssignmentEnabled',
    defaultMessage: 'Create Random Assignment Enabled',
    desc: TYPE_LABEL,
  },
  create_randomization_enabled: {
    id: 'PricingDetails.Feature.CreateRandomizationEnabled',
    defaultMessage: 'Question & page randomization',
    desc: TYPE_LABEL,
  },
  create_skip_logic_enabled: {
    id: 'PricingDetails.Feature.CreateSkipLogicEnabled',
    defaultMessage: 'Question & page skip logic',
    desc: TYPE_LABEL,
  },
  create_templates_enabled: {
    id: 'PricingDetails.Feature.CreateTemplatesEnabled',
    defaultMessage: 'Expert, pre-written survey templates',
    desc: TYPE_LABEL,
  },
  create_toggle_footer_enabled: {
    id: 'PricingDetails.Feature.CreateToggleFooterEnabled',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  custom_charts: {
    id: 'PricingDetails.Feature.CustomCharts',
    defaultMessage: 'Generate custom charts & reports',
    desc: TYPE_LABEL,
  },
  custom_question_bank: {
    id: 'PricingDetails.Feature.CustomQuestionBank',
    defaultMessage: 'Custom Question Bank',
    desc: TYPE_LABEL,
  },
  custom_subdomain: {
    id: 'PricingDetails.Feature.CustomSubdomain',
    defaultMessage: 'Custom subdomain',
    desc: TYPE_LABEL,
  },
  custom_templates: {
    id: 'PricingDetails.Feature.CustomTemplates',
    defaultMessage: 'Shared templates',
    desc: TYPE_LABEL,
  },
  custom_terms_of_use: {
    id: 'PricingDetails.Feature.CustomTermsOfUse',
    defaultMessage: 'Custom Terms of Use',
    desc: TYPE_LABEL,
  },
  customize_disqualification_page_enabled: {
    id: 'PricingDetails.Feature.CustomizeDisqualificationPageEnabled',
    defaultMessage: 'Display disqualification page',
    desc: TYPE_LABEL,
  },
  customer_success_manager: {
    id: 'PricingDetails.Feature.CustomerSuccessManager',
    defaultMessage: 'Customer Success Manager',
    desc: TYPE_LABEL,
  },
  dashboard: {
    id: 'PricingDetails.Feature.Dashboard',
    defaultMessage: 'Dashboard',
    desc: TYPE_LABEL,
  },
  data_ownership: {
    id: 'PricingDetails.Feature.DataOwnership',
    defaultMessage: 'Team ownership',
    desc: TYPE_LABEL,
  },
  disable_closed_page_branding_enabled: {
    id: 'PricingDetails.Feature.DisableClosedPageBrandingEnbabled',
    defaultMessage: 'Disable Closed Page Branding Enabled',
    desc: TYPE_LABEL,
  },
  disable_email_message_branding_enabled: {
    id: 'PricingDetails.Feature.DisableEmailMessageBrandingEnbabled',
    defaultMessage: 'Disable Email Message Branding Enabled',
    desc: TYPE_LABEL,
  },
  disable_footer_branding_enabled: {
    id: 'PricingDetails.Feature.DisableFooterBrandingEnbabled',
    defaultMessage: 'Disable Footer Branding Enabled',
    desc: TYPE_LABEL,
  },
  download_as_csv_xls_pdf: {
    id: 'PricingDetails.Feature.DownloadAsCsvXlsPdf',
    defaultMessage: 'Download results as CSV, XLS or PDF',
    desc: TYPE_LABEL,
  },
  download_as_ppt: {
    id: 'PricingDetails.Feature.DownloadAsPpt',
    defaultMessage: 'Download results in PPT format',
    desc: TYPE_LABEL,
  },
  email_support: {
    id: 'PricingDetails.Feature.EmailSupport',
    defaultMessage: '24/7 email support',
    desc: TYPE_LABEL,
  },
  email_tracking_enabled: {
    id: 'PricingDetails.Feature.EmailTrackingEnabled',
    defaultMessage: 'Track email responses',
    desc: TYPE_LABEL,
  },
  enable_ip_blocking: {
    id: 'PricingDetails.Feature.EnableIpBlocking',
    defaultMessage: 'Enable IP Blocking',
    desc: TYPE_LABEL,
  },
  essential_question_types: {
    id: 'PricingDetails.Feature.EssentialQuestionTypes',
    defaultMessage: 'Essential question types',
    desc: TYPE_LABEL,
  },
  extract_data: {
    id: 'PricingDetails.Feature.ExtractData',
    defaultMessage: 'Extract data',
    desc: TYPE_LABEL,
  },
  file_upload: {
    id: 'PricingDetails.Feature.FileUpload',
    defaultMessage: 'File upload',
    desc: TYPE_LABEL,
  },
  filter_crosstab: {
    id: 'PricingDetails.Feature.FilterCrosstab',
    defaultMessage: 'Crosstabs',
    desc: TYPE_LABEL,
  },
  funneling_enabled: {
    id: 'PricingDetails.Feature.FunnelingEnabled',
    defaultMessage: 'Funneling Enabled',
    desc: TYPE_LABEL,
  },
  global_settings: {
    id: 'PricingDetails.Feature.GlobalSettings',
    defaultMessage: 'Global settings',
    desc: TYPE_LABEL,
  },
  gold_features_included: {
    id: 'PricingDetails.Feature.GoldFeaturesIncluded',
    defaultMessage: 'Gold Features Included',
    desc: TYPE_LABEL,
  },
  group_contacts_limit: {
    id: 'PricingDetails.Feature.GroupContactsLimit',
    defaultMessage: 'Group Contacts Limit',
    desc: TYPE_LABEL,
  },
  group_templates: {
    id: 'PricingDetails.Feature.GroupTemplates',
    defaultMessage: 'Shared templates',
    desc: TYPE_LABEL,
  },
  groups_read: {
    id: 'PricingDetails.Feature.GroupsRead',
    defaultMessage: 'Groups Read',
    desc: TYPE_LABEL,
  },
  groups_write: {
    id: 'PricingDetails.Feature.GroupsWrite',
    defaultMessage: 'Groups Write',
    desc: TYPE_LABEL,
  },
  hide_export_branding_enabled: {
    id: 'PricingDetails.Feature.HideExportBrandingEnabled',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: TYPE_LABEL,
  },
  hipaa_enabled: {
    id: 'PricingDetails.Feature.HipaaEnabled',
    defaultMessage: 'HIPAA-compliant features',
    desc: TYPE_LABEL,
  },
  enterprise_only_integrations: {
    id: 'PricingDetails.Feature.EnterpriseOnlyIntegrations',
    defaultMessage: 'Enterprise-only integrations',
    desc: TYPE_LABEL,
  },
  kiosk_mode_inactivity_timer: {
    id: 'PricingDetails.Feature.KioskModeInactivityTimer',
    defaultMessage: 'Kiosk Mode: Inactivity Timer',
    desc: TYPE_LABEL,
  },
  kiosk_mode_passcode_lock: {
    id: 'PricingDetails.Feature.KioskModePasscodeLock',
    defaultMessage: 'Kiosk Mode: Passcode Lock',
    desc: TYPE_LABEL,
  },
  labeling_titles_numbering: {
    id: 'PricingDetails.Feature.LabelingTitlesNumbering',
    defaultMessage: 'Labeling, titles & numbering',
    desc: TYPE_LABEL,
  },
  library_read: {
    id: 'PricingDetails.Feature.LibraryRead',
    defaultMessage: SHARED_LIBRARY,
    desc: TYPE_LABEL,
  },
  lite_library: {
    id: 'PricingDetails.Feature.LiteLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: TYPE_LABEL,
  },
  max_collectors_per_survey: {
    id: 'PricingDetails.Feature.MaxCollectorsPerSurvey',
    defaultMessage: 'Number of collectors',
    desc: TYPE_LABEL,
  },
  matrix_question_type: {
    id: 'PricingDetails.Feature.MatrixQuestionType',
    defaultMessage: 'Matrix questions',
    desc: TYPE_LABEL,
  },
  maximum_daily_messages: {
    id: 'PricingDetails.Feature.MaximumDailyMessages',
    defaultMessage: 'Maximum Daily Message',
    desc: TYPE_LABEL,
  },
  menu_matrix_enabled: {
    id: 'PricingDetails.Feature.MenuMatrixEnabled',
    defaultMessage: 'Matrix of dropdown menus',
    desc: TYPE_LABEL,
  },
  metadata_settings: {
    id: 'PricingDetails.Feature.MetadataSettings',
    defaultMessage: 'Metadata Settings',
    desc: TYPE_LABEL,
  },
  mobile_apps_ios_android: {
    id: 'PricingDetails.Feature.MobileSdkPullResponseDataEnabled',
    defaultMessage: 'Mobile apps for iOS and Android',
    desc: TYPE_LABEL,
  },
  mobile_sdk_pull_response_data_enabled: {
    id: 'PricingDetails.Feature.MobileSdkPullResponseDataEnabled',
    defaultMessage: 'Mobile SDK - Data Pull',
    desc: TYPE_LABEL,
  },
  mta_sparkpost_low_risk_ip_pools: {
    id: 'PricingDetails.Feature.MtaSparkpostLowRiskIpPools',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools',
    desc: TYPE_LABEL,
  },
  multilingual: {
    id: 'PricingDetails.Feature.Multilingual',
    defaultMessage: 'Multilingual surveys',
    desc: TYPE_LABEL,
  },
  multiple_block_rotation_enabled: {
    id: 'PricingDetails.Feature.MultipleBlockRotationEnabled',
    defaultMessage: 'Block randomization',
    desc: TYPE_LABEL,
  },
  multiple_users: {
    id: 'PricingDetails.Feature.MultipleUsers',
    defaultMessage: 'Multiple Users',
    desc: TYPE_LABEL,
  },
  new_stock_themes: {
    id: 'PricingDetails.Feature.NewStockThemes',
    defaultMessage: 'Custom themes, colors & more',
    desc: TYPE_LABEL,
  },
  notification_center: {
    id: 'PricingDetails.Feature.NotificationCenter',
    defaultMessage: 'Notification Center',
    desc: TYPE_LABEL,
  },
  num_free_responses: {
    id: 'PricingDetails.Feature.NumFreeResponses',
    defaultMessage: RESPONSES_PER_YEAR,
    desc: TYPE_LABEL,
  },
  onboarding: {
    id: 'PricingDetails.Feature.Onboarding',
    defaultMessage: 'Onboarding',
    desc: TYPE_LABEL,
  },
  pagination: {
    id: 'PricingDetails.Feature.Pagination',
    defaultMessage: 'Pagination',
    desc: TYPE_LABEL,
  },
  paid_to_group_rollout: {
    id: 'PricingDetails.Feature.PaidToGroupRollout',
    defaultMessage: 'Paid To Group Rollout',
    desc: TYPE_LABEL,
  },
  papi_enabled: {
    id: 'PricingDetails.Feature.PapiEnabled',
    defaultMessage: 'Papi Enabled',
    desc: TYPE_LABEL,
  },
  password_protection: {
    id: 'PricingDetails.Feature.PasswordProtection',
    defaultMessage: 'Password-protected surveys',
    desc: TYPE_LABEL,
  },
  payment_qt: {
    id: 'PricingDetails.Feature.PaymentQT',
    defaultMessage: 'Accept payments',
    desc: TYPE_LABEL,
  },
  phone_support: {
    id: 'PricingDetails.Feature.PhoneSupport',
    defaultMessage: 'Phone support',
    desc: TYPE_LABEL,
  },
  plans_benchmarks: {
    id: 'PricingDetails.Feature.PlansBenchmark',
    defaultMessage: GLOBAL_BENCHMARKS,
    desc: TYPE_LABEL,
  },
  pop_up_collector: {
    id: 'PricingDetails.Feature.PopupCollector',
    defaultMessage: 'Pop up online surveys',
    desc: TYPE_LABEL,
  },
  premium_themes: {
    id: 'PricingDetails.Feature.PremiumThemes',
    defaultMessage: 'Premium themes',
    desc: TYPE_LABEL,
  },
  priority_email_support: {
    id: 'PricingDetails.Feature.PrimaryEmailSupport',
    defaultMessage: 'Expedited email support',
    desc: TYPE_LABEL,
  },
  private_apps: {
    id: 'PricingDetails.Feature.PrivateApps',
    defaultMessage: 'Unlimited API access',
    desc: TYPE_LABEL,
  },
  progress_bar: {
    id: 'PricingDetails.Feature.ProgressBar',
    defaultMessage: 'Progress bar',
    desc: TYPE_LABEL,
  },
  question_library: {
    id: 'PricingDetails.Feature.QuestionLibrary',
    defaultMessage: 'Question Bank approved questions',
    desc: TYPE_LABEL,
  },
  question_library_intl: {
    id: 'PricingDetails.Feature.QuestionLibraryIntl',
    defaultMessage: 'Question Bank approved questions',
    desc: TYPE_LABEL,
  },
  quiz_scoring_and_instant_results: {
    id: 'PricingDetails.Feature.QuizScoring',
    defaultMessage: 'Quiz scoring & instant results',
    desc: TYPE_LABEL,
  },
  quizzes_pro: {
    id: 'PricingDetails.Feature.QuizzesPro',
    defaultMessage: 'Quizzes pro',
    desc: TYPE_LABEL,
  },
  randomize_answer_choices: {
    id: 'PricingDetails.Feature.RandomizeAnswerChoices',
    defaultMessage: 'Randomize answer choices',
    desc: TYPE_LABEL,
  },
  ranking_question_type: {
    id: 'PricingDetails.Feature.RankingQuestionType',
    defaultMessage: 'Ranking questions',
    desc: TYPE_LABEL,
  },
  rating_question_type: {
    id: 'PricingDetails.Feature.RatingQuestionType',
    defaultMessage: 'Rating questions',
    desc: TYPE_LABEL,
  },
  real_time_results: {
    id: 'PricingDetails.Feature.RealTimeResults',
    defaultMessage: 'Real time results',
    desc: TYPE_LABEL,
  },
  receive_transferred_survey_enabled: {
    id: 'PricingDetails.Feature.ReceiveTransferredSurveyEnabled',
    defaultMessage: 'Receive Transferred Survey Enabled',
    desc: TYPE_LABEL,
  },
  record_respondent_email_address: {
    id: 'PricingDetails.Feature.RecordRespondentEmailAddress',
    defaultMessage: 'Record respondent email address',
    desc: TYPE_LABEL,
  },
  recurring_email_collector_enabled: {
    id: 'PricingDetails.Feature.RecurringEmailCollectorEnabled',
    defaultMessage: 'Recurring surveys',
    desc: TYPE_LABEL,
  },
  recurring_surveys: {
    id: 'PricingDetails.Feature.RecurringSurveys',
    defaultMessage: 'Recurring surveys',
    desc: TYPE_LABEL,
  },
  require_answer: {
    id: 'PricingDetails.Feature.RequireAnswer',
    defaultMessage: 'Require answer completion',
    desc: TYPE_LABEL,
  },
  reshare: {
    id: 'PricingDetails.Feature.Reshare',
    defaultMessage: 'Reshare',
    desc: TYPE_LABEL,
  },
  respondent_receipt: {
    id: 'PricingDetails.Feature.RespondentReceipt',
    defaultMessage: 'Confirmation Email to Respondents',
    desc: TYPE_LABEL,
  },
  response_quality_enabled: {
    id: 'PricingDetails.Feature.ResponseQualityEnabled',
    defaultMessage: 'Response Quality',
    desc: TYPE_LABEL,
  },
  responses_read: {
    id: 'PricingDetails.Feature.ResponsesRead',
    defaultMessage: 'Responses Read',
    desc: TYPE_LABEL,
  },
  responses_read_detail: {
    id: 'PricingDetails.Feature.ResponsesReadDetail',
    defaultMessage: 'Responses Read Detail',
    desc: TYPE_LABEL,
  },
  responses_write: {
    id: 'PricingDetails.Feature.ResponsesWrite',
    defaultMessage: 'Responses Write',
    desc: TYPE_LABEL,
  },
  roles_read: {
    id: 'PricingDetails.Feature.RolesRead',
    defaultMessage: 'Roles Read',
    desc: TYPE_LABEL,
  },
  roles_write: {
    id: 'PricingDetails.Feature.RolesWrite',
    defaultMessage: 'Roles Write',
    desc: TYPE_LABEL,
  },
  sa_en_ga: {
    id: 'PricingDetails.Feature.SaEnGa',
    defaultMessage: 'SA EN GA',
    desc: TYPE_LABEL,
  },
  select_features_included: {
    id: 'PricingDetails.Feature.SelectFeaturesIncluded',
    defaultMessage: 'Select Features Included',
    desc: TYPE_LABEL,
  },
  send_surveys: {
    id: 'PricingDetails.Feature.SendSurveys',
    defaultMessage: 'Send Surveys',
    desc: TYPE_LABEL,
  },
  set_max_response_count: {
    id: 'PricingDetails.Feature.SetMaxResponseCount',
    defaultMessage: 'Set Max Response Count',
    desc: TYPE_LABEL,
  },
  set_survey_end_date: {
    id: 'PricingDetails.Feature.SetSurveyEndDate',
    defaultMessage: 'Set survey end date',
    desc: TYPE_LABEL,
  },
  share_surveys: {
    id: 'PricingDetails.Feature.ShareSurveys',
    defaultMessage: 'Share survey data',
    desc: TYPE_LABEL,
  },
  share_with_your_organization: {
    id: 'PricingDetails.Feature.ShareWithYourOrganization',
    defaultMessage: 'Share With Your Organization',
    desc: TYPE_LABEL,
  },
  shared_group_library: {
    id: 'PricingDetails.Feature.SharedGroupLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: TYPE_LABEL,
  },
  shared_library: {
    id: 'PricingDetails.Feature.SharedLibrary',
    defaultMessage: SHARED_LIBRARY,
    desc: TYPE_LABEL,
  },
  show_create_crosstab: {
    id: 'PricingDetails.Feature.ShowCreateCrosstab',
    defaultMessage: 'Crosstabs',
    desc: TYPE_LABEL,
  },
  show_create_header_upgrade_button: {
    id: 'PricingDetails.Feature.ShowCreateHeaderUpgradeButton',
    defaultMessage: 'Show Create Header Upgrade Button',
    desc: TYPE_LABEL,
  },
  show_sig_diffs_enabled: {
    id: 'PricingDetails.Feature.ShowSigDiffsEnabled',
    defaultMessage: 'Statistical significance',
    desc: TYPE_LABEL,
  },
  single_sign_on: {
    id: 'PricingDetails.Feature.SingleSignOn',
    defaultMessage: 'Single sign-on',
    desc: TYPE_LABEL,
  },
  slider_question_type: {
    id: 'PricingDetails.Feature.SliderQuestionType',
    defaultMessage: 'Slider questions',
    desc: TYPE_LABEL,
  },
  smart_notifications: {
    id: 'PricingDetails.Feature.SmartNotifications',
    defaultMessage: 'Smart Notifications',
    desc: TYPE_LABEL,
  },
  ssl_tls_encryption: {
    id: 'PricingDetails.Feature.SslTlsEncryption',
    defaultMessage: 'SSL/TLS Encryption',
    desc: TYPE_LABEL,
  },
  star_rating_question_type: {
    id: 'PricingDetails.Feature.StarRatingQuestionType',
    defaultMessage: 'Rating questions',
    desc: TYPE_LABEL,
  },
  survey_branding: {
    id: 'PricingDetails.Feature.SurveyBranding',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: TYPE_LABEL,
  },
  survey_create_limit: {
    id: 'PricingDetails.Feature.SurveyCreateLimit',
    defaultMessage: 'Number of surveys',
    desc: TYPE_LABEL,
  },
  survey_templates_intl: {
    id: 'PricingDetails.Feature.SurveyTemplatesIntl',
    defaultMessage: 'Expert, pre-written survey templates',
    desc: TYPE_LABEL,
  },
  surveys_read: {
    id: 'PricingDetails.Feature.SurveysRead',
    defaultMessage: 'Surveys Read',
    desc: TYPE_LABEL,
  },
  surveys_write: {
    id: 'PricingDetails.Feature.SurveysWrite',
    defaultMessage: 'Surveys Write',
    desc: TYPE_LABEL,
  },
  team_activity: {
    id: 'PricingDetails.Feature.TeamActivity',
    defaultMessage: 'Team activity',
    desc: TYPE_LABEL,
  },
  team_ownership: {
    id: 'PricingDetails.Feature.TeamOwnership',
    defaultMessage: 'Team ownership',
    desc: TYPE_LABEL,
  },
  team_themes: {
    id: 'PricingDetails.Feature.TeamThemes',
    defaultMessage: 'Shared themes',
    desc: TYPE_LABEL,
  },
  teams_can_discover: {
    id: 'PricingDetails.Feature.TeamsCanDiscover',
    defaultMessage: 'Teams Can Discover',
    desc: TYPE_LABEL,
  },
  teams_can_make_discoverable: {
    id: 'PricingDetails.Feature.TeamsCanMakeDiscoverable',
    defaultMessage: 'Teams Can Make Discoverable',
    desc: TYPE_LABEL,
  },
  teams_enabled: {
    id: 'PricingDetails.Feature.TeamsEnabled',
    defaultMessage: 'Teams Enabled',
    desc: TYPE_LABEL,
  },
  text_analysis: {
    id: 'PricingDetails.Feature.TextAnalysis',
    defaultMessage: 'Text analysis',
    desc: TYPE_LABEL,
  },
  text_formatting: {
    id: 'PricingDetails.Feature.TextFormatting',
    defaultMessage: 'Text formatting',
    desc: TYPE_LABEL,
  },
  textbox_multiple_question_type: {
    id: 'PricingDetails.Feature.TextboxMultipleQuestionType',
    defaultMessage: 'Textbox Multiple Question Type',
    desc: TYPE_LABEL,
  },
  track_email_responses: {
    id: 'PricingDetails.Feature.TrackEmailResponses',
    defaultMessage: 'Track Email Responses',
    desc: TYPE_LABEL,
  },
  try_before_you_buy_enabled: {
    id: 'PricingDetails.Feature.TryBeforeYouBuyEnabled',
    defaultMessage: 'Try Before You Buy Enabled',
    desc: TYPE_LABEL,
  },
  unlimited_responses: {
    id: 'PricingDetails.Feature.UnlimitedResponses',
    defaultMessage: 'Unlimited surveys and questions',
    desc: TYPE_LABEL,
  },
  user_management: {
    id: 'PricingDetails.Feature.UserManagment',
    defaultMessage: 'Additional Users',
    desc: TYPE_LABEL,
  },
  users_read: {
    id: 'PricingDetails.Feature.UsersRead',
    defaultMessage: 'Users Read',
    desc: TYPE_LABEL,
  },
  validate_answer: {
    id: 'PricingDetails.Feature.ValidateAnswer',
    defaultMessage: 'Answer validation',
    desc: TYPE_LABEL,
  },
  video_question_type: {
    id: 'PricingDetails.Feature.VideoQuestionType',
    defaultMessage: 'Video and image questions',
    desc: TYPE_LABEL,
  },
  view_respondent_ip_address: {
    id: 'PricingDetails.Feature.ViewRespondentIpAddrress',
    defaultMessage: `View respondent's IP address`,
    desc: TYPE_LABEL,
  },
  web_social_email_responses: {
    id: 'PricingDetails.Feature.WebSocialEmailResponses',
    defaultMessage: 'Get responses via web, social or email',
    desc: TYPE_LABEL,
  },
  webhooks_read: {
    id: 'PricingDetails.Feature.WebhooksRead',
    defaultMessage: 'Webhooks Read',
    desc: TYPE_LABEL,
  },
  webhooks_write: {
    id: 'PricingDetails.Feature.WebhooksWrite',
    defaultMessage: 'Webhooks Write',
    desc: TYPE_LABEL,
  },
  word_cloud_combine_hide: {
    id: 'PricingDetails.Feature.WordCloudCombineHide',
    defaultMessage: 'Word clouds: Combine or hide words',
    desc: TYPE_LABEL,
  },
  workgroups_members_read: {
    id: 'PricingDetails.Feature.WorkgroupsMembersRead',
    defaultMessage: 'Workgroups Members Read',
    desc: TYPE_LABEL,
  },
  workgroups_members_write: {
    id: 'PricingDetails.Feature.WorkgroupsMembersWrite',
    defaultMessage: 'Workgroups Members Write',
    desc: TYPE_LABEL,
  },
  workgroups_read: {
    id: 'PricingDetails.Feature.WorkgroupsRead',
    defaultMessage: 'Workgroups Read',
    desc: TYPE_LABEL,
  },
  workgroups_shares_read: {
    id: 'PricingDetails.Feature.WorkgroupsSharesRead',
    defaultMessage: 'Workgroups Shares Read',
    desc: TYPE_LABEL,
  },
  workgroups_shares_write: {
    id: 'PricingDetails.Feature.WorkgroupsSharesWrite',
    defaultMessage: 'Workgroups Shares Write',
    desc: TYPE_LABEL,
  },
  workgroups_write: {
    id: 'PricingDetails.Feature.WorkgroupsWrite',
    defaultMessage: 'Workgroups Write',
    desc: TYPE_LABEL,
  },
});
